import { forwardRef } from 'react';
import InputField from '../shared/Fields/InputField';

export const DateInputField = forwardRef(
  (
    {
      onClick,
      formError,
      disabled,
      placeholder,
      label,
      fieldKey,
      overrideValue,
      icon,
      formData,
      setFormData,
      required = false
    }: any,
    ref
  ) => {
    return (
      <InputField
        overrideValue={overrideValue}
        className="w-full"
        type="text"
        id={fieldKey}
        label={label}
        placeholder={placeholder}
        fieldKey={fieldKey}
        required={required}
        formData={formData}
        setFormData={setFormData}
        autoComplete=""
        formError={formError}
        disabled={disabled}
        onClick={onClick}
        ref={ref}
        onBlurhandler={() => {}}
        handleChange={() => {}}
        CustomIcon={icon}
      />
    );
  }
);
